import { Controller } from "@hotwired/stimulus"

// Phase 2.12 Tier 4 — Vendor scorecard weights editor.
// Captain/commander-only modal that PATCHes 4 weight values into
// companies.portfolio_settings.vendor_score_weights. Validates the four
// weights sum to 100 before allowing save.
export default class extends Controller {
  static targets = ["coPct", "onTime", "warranty", "risks", "sumLabel", "errors", "submitBtn"]
  static values = { url: String }

  connect() {
    this._renderSum()
  }

  onEdit() {
    this._renderSum()
  }

  resetDefaults() {
    this.coPctTarget.value = 40
    this.onTimeTarget.value = 30
    this.warrantyTarget.value = 20
    this.risksTarget.value = 10
    this._renderSum()
  }

  async save() {
    const sum = this._sum()
    if (sum !== 100) {
      this._showError(`Weights must sum to 100 (currently ${sum}).`)
      return
    }
    this.submitBtnTarget.disabled = true

    const body = new FormData()
    body.append("vendor_score_weights[co_pct]", (this._val(this.coPctTarget) / 100).toFixed(4))
    body.append("vendor_score_weights[on_time]", (this._val(this.onTimeTarget) / 100).toFixed(4))
    body.append("vendor_score_weights[warranty]", (this._val(this.warrantyTarget) / 100).toFixed(4))
    body.append("vendor_score_weights[risks]", (this._val(this.risksTarget) / 100).toFixed(4))

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
          Accept: "application/json"
        },
        body
      })
      const data = await response.json()
      if (!response.ok || !data.success) {
        this._showError((data.errors || ["Save failed"]).join(", "))
        return
      }
      window.location.reload()
    } catch (e) {
      this._showError("Network error")
    } finally {
      this.submitBtnTarget.disabled = false
    }
  }

  _val(target) {
    return Math.max(0, Math.min(100, parseInt(target.value, 10) || 0))
  }

  _sum() {
    return this._val(this.coPctTarget) +
           this._val(this.onTimeTarget) +
           this._val(this.warrantyTarget) +
           this._val(this.risksTarget)
  }

  _renderSum() {
    const sum = this._sum()
    this.sumLabelTarget.textContent = `${sum}%`
    this.sumLabelTarget.className = sum === 100
      ? "font-medium text-emerald-600"
      : "font-medium text-red-600"
    if (sum === 100) {
      this.errorsTarget.classList.add("hidden")
    }
  }

  _showError(message) {
    this.errorsTarget.textContent = message
    this.errorsTarget.classList.remove("hidden")
  }
}
